module.exports = __webpack_public_path__ + "static/media/Antenna_start.fa48d27d.mp4";